/* eslint-disable no-empty-pattern */
import React, { useState, useEffect } from 'react';
import { ButtonWrapper, ConfigWrapper, FormWrapper, Title, } from './FilterConfigurator.Styles';
import { Button, Divider, Step, StepContent, StepLabel, Stepper, } from '@material-ui/core';
import { Form, Formik, Field } from 'formik';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { SubName } from '../../commons/style/MUI.Styles';
import { filterSortValidationSchema } from '../../commons/validation/FilterSortValidation';
import { filterSortInitialValues } from '../../commons/assets/InitialValues';
import { ConfigurationForm } from '../ConfigurationForm';
import { SQLForm } from '../SQLForm';
import { EditableTextField } from '../../commons/EditableTextField';
import { AccountSelector } from '../../commons/AccountSelector';
import { accounts } from '../../../frontend-config';
import { config_baseURL, set_config_baseURL, baseURL, } from '../../../api/utils';
export var FilterConfigurator = function (_a) {
    var contactLists = _a.contactLists, handleDiscard = _a.handleDiscard, addFilter = _a.addFilter, filters = _a.filters, creating = _a.creating, selectedRow = _a.selectedRow, updateFilterByID = _a.updateFilterByID, copied = _a.copied, readOnly = _a.readOnly, validateFilter = _a.validateFilter, returnedRecords = _a.returnedRecords, onAlert = _a.onAlert, onAccountChange = _a.onAccountChange;
    var step = useState(0)[0];
    var _b = useState(true), openStepOne = _b[0], setOpenStepOne = _b[1];
    var _c = useState(true), openStepTwo = _c[0], setOpenStepTwo = _c[1];
    var _d = useState(selectedRow), selectedFilter = _d[0], setSelectedFilter = _d[1];
    var _e = useState({
        title: '',
        message: '',
        status: false
    }), openAlert = _e[0], setOpenAlert = _e[1];
    var _f = useState(''), filterType = _f[0], setFilterType = _f[1];
    var _g = useState(''), filterOrSort = _g[0], setFilterOrSort = _g[1];
    var _h = useState(), configAccount = _h[0], setConfigAccount = _h[1];
    // useMemo(() => {
    //   if (openAlert.status === true) {
    //     if (returnedRecords.returnedRecords.isSuccess) {
    //       const { Total } = returnedRecords.returnedRecords.data.returnData[0];
    //       const message =
    //         filterOrSort === 'sort'
    //           ? 'Total = 0, your sort is successful'
    //           : `${Total} ${
    //               filterType === 'Account' || filterType === 'phone'
    //                 ? 'phone numbers'
    //                 : 'contacts'
    //             } match your filter`;
    //       setOpenAlert({ title: 'Validated Records', message, status: true });
    //     } else if (!returnedRecords.returnedRecords.isSuccess) {
    //       setOpenAlert({
    //         title: 'Validation Error',
    //         message: returnedRecords.returnedRecords.statusMessage,
    //         status: true,
    //       });
    //     }
    //   }
    // }, [returnedRecords.returnedRecords]);
    var onValidate = function (data) {
        var returnedRecords = data.action.payload.data[0];
        if (returnedRecords.isSuccess) {
            var Total = returnedRecords.data.returnData[0].Total;
            var message = filterOrSort === 'sort'
                ? 'Total = 0, your sort is successful'
                : Total + " " + (filterType === 'Account' || filterType === 'phone'
                    ? 'phone numbers'
                    : 'contacts') + " match your filter";
            setOpenAlert({ title: 'Validated Records', message: message, status: true });
        }
        else if (!returnedRecords.isSuccess) {
            setOpenAlert({
                title: 'Validation Error',
                message: returnedRecords.statusMessage,
                status: true
            });
        }
    };
    var handleDiscardForm = function (resetForm) {
        resetForm();
        handleDiscard();
        setSelectedFilter(null);
    };
    var handleSubmit = function (submitForm) {
        submitForm();
    };
    var handleClose = function () {
        setOpenAlert({ title: '', message: '', status: false });
    };
    useEffect(function () {
        setSelectedFilter(selectedRow);
        if (selectedRow && selectedRow.prjacc) {
            setConfigAccount(accounts.find(function (a) { return a.url === selectedRow.prjacc.url; }));
            set_config_baseURL(selectedRow.prjacc.url);
        }
        else if (selectedRow && JSON.stringify(selectedRow) !== '{}') {
            setConfigAccount(accounts.find(function (a) { return a.url === baseURL(); }));
            onAccountChange(baseURL());
            set_config_baseURL(baseURL());
        }
        else {
            setConfigAccount(accounts.find(function (a) { return a.url === config_baseURL(); }));
            onAccountChange(config_baseURL());
        }
    }, [selectedRow]);
    var onSend = function (value, resetForm) {
        var filter = {
            filterName: value.filterName,
            tableCL: value.tableCL,
            filterType: value.filterType,
            filterOrSort: value.filterOrSort,
            filterSQL: value.filterSQL
        };
        if (!creating && !copied) {
            updateFilterByID(filter, selectedRow.id, selectedFilter);
        }
        else {
            addFilter(filter);
        }
        handleDiscardForm(resetForm);
    };
    var setFormValues = function (setValues) {
        var filter = selectedFilter;
        if (filter && Object.keys(filter).length > 0) {
            var template = {
                filterName: filter.filterName,
                filterType: filter.filterType,
                tableCL: filter.tableCL,
                filterOrSort: filter.filterOrSort,
                filterSQL: filter.filterSQL,
                sqlInput: 'freeform'
            };
            setValues(template);
        }
    };
    var checkFilterName = function (formValues) {
        var lowerCheck = formValues.filterName.toLowerCase();
        var filterCheck = filters.filter(function (fil) {
            return fil.filterName.toLowerCase() === lowerCheck;
        });
        return (filterCheck.length === 0 ||
            (filterCheck.length > 0 &&
                !creating &&
                formValues.filterName === (selectedFilter === null || selectedFilter === void 0 ? void 0 : selectedFilter.filterName)));
    };
    return (React.createElement(FormWrapper, null,
        React.createElement(Formik, { initialValues: filterSortInitialValues, validationSchema: filterSortValidationSchema, onSubmit: function (values, _a) {
                var setSubmitting = _a.setSubmitting, resetForm = _a.resetForm;
                if (!checkFilterName(values)) {
                    onAlert('This Filter Name is already in use please use a new one', 'warning');
                }
                else {
                    onSend(values, resetForm);
                }
                setSubmitting(false);
            } }, function (_a) {
            var submitForm = _a.submitForm, isSubmitting = _a.isSubmitting, resetForm = _a.resetForm, setValues = _a.setValues, values = _a.values, setFieldValue = _a.setFieldValue, touched = _a.touched, errors = _a.errors;
            return (React.createElement(Form, null,
                useEffect(function () {
                    setTimeout(function () {
                        setFormValues(setValues);
                    }, 200);
                }, [selectedFilter]),
                React.createElement(Title, { variant: 'h5', gutterBottom: true },
                    React.createElement(Field, { name: 'filterName', label: 'Filter Name', component: EditableTextField }),
                    React.createElement(SubName, { variant: 'body2' }, selectedFilter && selectedFilter.id)),
                React.createElement(Divider, null),
                React.createElement(ConfigWrapper, null,
                    React.createElement(AccountSelector, { initialValue: configAccount, onValueChange: function (account) {
                            if (account && account !== 'All') {
                                setConfigAccount(account);
                                onAccountChange(account.url);
                                set_config_baseURL(account.url);
                            }
                        }, fullWidth: true, noAll: true, disabled: !creating })),
                React.createElement(Divider, null),
                React.createElement(Stepper, { activeStep: step, orientation: 'vertical' },
                    React.createElement(Step, { active: openStepOne },
                        React.createElement(StepLabel, { onClick: function () {
                                setOpenStepOne(!openStepOne);
                            } }, "Configuration"),
                        React.createElement(StepContent, null,
                            React.createElement(ConfigurationForm, { readOnly: readOnly, values: values, setFieldValue: setFieldValue, touched: touched, errors: errors, contactLists: contactLists }))),
                    React.createElement(Step, { active: openStepTwo },
                        React.createElement(StepLabel, { onClick: function () {
                                setOpenStepTwo(!openStepTwo);
                            } }, "SQL"),
                        React.createElement(StepContent, null,
                            React.createElement(SQLForm, { setFieldValue: setFieldValue, formValues: values }))),
                    React.createElement(Step, { expanded: true },
                        React.createElement(StepContent, null,
                            React.createElement(ButtonWrapper, null,
                                React.createElement(Button, { variant: 'contained', color: 'primary', disabled: isSubmitting || readOnly, onClick: function () { return handleSubmit(submitForm); } }, creating === true ? 'Create' : 'Update'),
                                React.createElement(Button, { variant: 'contained', color: 'primary', onClick: function () { return handleDiscardForm(resetForm); } }, readOnly ? 'Close' : 'Discard'),
                                React.createElement(Button, { variant: 'contained', color: 'primary', onClick: function () {
                                        var filter = {
                                            filterName: values.filterName,
                                            tableCL: values.tableCL,
                                            filterType: values.filterType,
                                            filterOrSort: values.filterOrSort,
                                            filterSQL: values.filterSQL
                                        };
                                        setFilterType(values.filterType);
                                        setFilterOrSort(values.filterOrSort);
                                        validateFilter(filter, function (data) {
                                            //  console.log('validation-data', data);
                                            onValidate(data);
                                        });
                                        // setTimeout(() => {
                                        //   setOpenAlert({
                                        //     title: '',
                                        //     message: '',
                                        //     status: true,
                                        //   });
                                        // }, 300);
                                    } }, "Validate"))))),
                React.createElement(Dialog, { open: openAlert.status, onClose: function () { return handleClose(); }, "aria-labelledby": 'alert-name', "aria-describedby": 'alert-dialog-description' },
                    React.createElement(DialogTitle, { id: 'alert-name' }, openAlert.title),
                    React.createElement(DialogContent, null,
                        React.createElement(DialogContentText, { id: 'alert-dialog-description' }, openAlert.message)),
                    React.createElement(DialogActions, null,
                        React.createElement(Button, { onClick: function () { return handleClose(); }, color: 'primary' }, "Confirm")))));
        })));
};
FilterConfigurator.defaultProps = {
// bla: 'test',
};
//# sourceMappingURL=FilterConfigurator.js.map